<template>
  <div>
    <el-row>
      <label class="el-form-item__label" style="width: 100px"
        ><span style="color: red">*</span> 导入文件：</label
      >
      <el-col :span="8">
        <el-upload
          ref="fileName"
          action=""
          :headers="headers"
          :http-request="handleHttpRequest"
          :file-list="upFiles"
          :before-upload="beforeUpload"
          :on-change="uploadfilechange"
          :on-success="uploadifle"
          :on-remove="removefile"
          :auto-upload="true"
          :accept="acceptType()"
          :limit="1"
        >
          <el-button size="small" type="primary" icon="el-icon-upload"
            >添加文件</el-button
          >
          <div
            slot="tip"
            class="el-upload__tip"
            style="font-size: 14px; color: #999"
          >
            支持扩展名：{{
              ossUploadParams.uploadType === "csv" ? ".csv" : ".xls，.xlsx"
            }}
          </div>
        </el-upload>
      </el-col>
      <el-link type="primary" :underline="false" @click="downloadFile"
        >下载文件模板</el-link
      >
    </el-row>
    <el-dialog
      width="30%"
      title="导入"
      :visible.sync="innerSuccessVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <p class="big green">文件上传成功</p>
      <div
        slot="footer"
        class="dialog-footer"
        style="display: flex; align-items: center; justify-content: center"
      >
        <el-button @click="innerSuccessVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitFile">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title="导入"
      :visible.sync="innerFailedVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <p class="big red">文件上传失败</p>
      <p style="text-align: center; padding-top: 10px">
        <a :href="errorUrl" download="errorExcel">下载文件解析结果</a
        >（请根据错误原因更新文件后重新提交）
      </p>
      <div
        slot="footer"
        class="dialog-footer"
        style="display: flex; align-items: center; justify-content: center"
      >
        <el-button @click="innerFailedVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Client from "@/utils/client.js";
import {
  fileUpload,
  getTemplateUrl,
  analyzeFile,
  analyzeResult,
  submitFile,
} from "./index.js";
export default {
  inheritAttrs: false,
  props: ["ossUploadParams"],
  data() {
    return {
      headers: {
        authorization: "*",
      },
      timer: null,
      token: "",
      count: 300,
      requestUrls: "",
      errorUrl: "",
      dataObj: null,
      upFiles: [],
      innerSuccessVisible: false,
      innerFailedVisible: false,
    };
  },
  computed: {
    acceptType: function () {
      return function () {
        return this.ossUploadParams.uploadType === "csv"
          ? ".csv,.CSV,.text/csv"
          : ".xls,.xlsx,.XLS,.XLSX";
      };
    },
  },
  methods: {
    async downloadFile() {
      let res = await getTemplateUrl(this.ossUploadParams.templateUrl);
      const blob = res;
      const fileName = 'sample.csv';
      this.downloadFile2(blob, fileName);
    },
    downloadFile2(blob, fileName) {
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
    downModel(resData) {
      let script = document.createElement("a");
      var tempUr = resData.split("/").pop();
      script.setAttribute("href", resData);
      script.setAttribute("download", `${tempUr}.xlsx`);
      document.body.appendChild(script);
      script.click();
      document.body.removeChild(script);
    },
    async fileUpload() {
      let resData = (await fileUpload()).data;
      this.dataObj = resData;
    },
    submitUpload() {
      this.$refs.elForm.clearValidate("fileName");
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        !this.upFiles.length && this.$message.warning("请选择文件!");
        this.$refs.fileName.submit();
      });
    },
    beforeUpload(file) {
      // const pricePatternText = uploadType ? '.csv,.CSV' : '.xls,.xlsx';
      // let isAccept = new RegExp(pricePatternText).test(file.type)
      // if (!isAccept) {
      //   this.$message.error(uploadType ? '上传文件格式非法，请上传csv文件' : '上传文件格式非法，请请上传excel文件')
      // }
      // return isAccept
    },
    uploadfilechange(file, fileList) {
      this.upFiles = [];
      this.upFiles = fileList;
    },
    uploadifle(response, file, fileList) {},
    removefile(file, fileList) {
      this.upFiles = fileList;
      this.requestUrls = "";
    },
    async handleHttpRequest(option) {
      //上传OSS
      try {
        const client = Client(this.dataObj),
          file = option.file;
        const random_name =
          "tmp/" +
          this.random_string(6) +
          "_" +
          new Date().getTime() +
          "." +
          file.name.split(".").pop();
        await client
          .put(random_name, file)
          .then(({ res }) => {
            if (res.statusCode === 200) {
              this.requestUrls = res.requestUrls[0];
              // this.$message.success('文件上传成功');
              //解析
              this.analys();
            } else {
              option.onError("上传失败");
            }
          })
          .catch((error) => {
            console.log(error);
            option.onError("上传失败");
          });
      } catch (error) {
        console.log(error);
        option.onError("上传失败");
      }
    },
    async analys() {
      try {
        var tempUr = this.requestUrls.split("/").pop();
        if (!tempUr) {
          this.$message.error("文件地址不存在，请上传文件");
          return false;
        }
        this.$store.commit("setPageLoading", true);
        var obj = {
          fileName: this.requestUrls.split("/").pop(),
          vendorId: this.ossUploadParams.vendorId,
        };
        let res = await analyzeFile(this.ossUploadParams.analyzeFileUrl, obj);
        if (res.success) {
          if (this.ossUploadParams.noRoundRobin === true) {
            this.innerSuccessVisible = true;
            this.$store.commit("setPageLoading", false);
            return;
          }
          this.setTimer(2000, tempUr);
        } else if (res.code == 1029) {
          if (this.ossUploadParams.noRoundRobin === true) {
            this.errorUrl = res.message;
            this.innerSuccessVisible = false;
            this.innerFailedVisible = true;
            this.removefile();
            this.$store.commit("setPageLoading", false);
            return;
          }
        } else {
          if (this.ossUploadParams.noRoundRobin === true) {
            this.$message.error(`${res.message}`);
            this.removefile();
            this.$store.commit("setPageLoading", false);
            return;
          }
          this.$message.error(`${res.message}`);
          this.$store.commit("setPageLoading", false);
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("setPageLoading", false);
        !this.ossUploadParams.specialCodeStatus &&
          this.$message.error("文件解析失败");
      }
    },
    setTimer(intMilliecond, tempUr) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getLoopPercent(tempUr);
      }, intMilliecond);
    },
    async getLoopPercent(tempUr) {
      if (this.count < 0) {
        clearInterval(this.timer);
        this.count = 300;
        this.$store.commit("setPageLoading", false);
        this.$message.error("解析超时");
        return;
      }
      this.count -= 1;
      try {
        let res = await analyzeResult(this.ossUploadParams.analyzeResultUrl, {
          fileName: this.requestUrls.split("/").pop(),
          taskCode: "import_validate_sku_discount",
        });
        if (res.success && res.data) {
          if (res.data.isSucceed) {
            //解析成功
            this.innerSuccessVisible = true;
            this.$store.commit("setPageLoading", false);
            clearInterval(this.timer);
          }
          if (res.data.isSucceed === false && res.data.fileUrl) {
            //解析失败
            clearInterval(this.timer);
            this.errorUrl = res.data.fileUrl.replace('http://', 'https://');
            this.innerSuccessVisible = false;
            this.innerFailedVisible = true;
            res.data.message && this.$message.error(`${res.data.message}`);
            this.removefile();
            this.$store.commit("setPageLoading", false);
          }
          if (res.data.isSucceed == null) {
            //正在解析
            console.error("正在解析");
          }
        } else {
          this.$store.commit("setPageLoading", false);
          clearInterval(this.timer);
          this.$message.error(`${res.message}`);
        }
      } catch (err) {
        this.$store.commit("setPageLoading", false);
        // this.$message.error('文件解析失败');
        clearInterval(this.timer);
      }
    },
    async submitFile() {
      this.$store.commit("setPageLoading", true);
      var obj = {
        fileName: this.requestUrls.split("/").pop(),
        vendorId: this.ossUploadParams.vendorId,
      };
      const res = await submitFile(this.ossUploadParams.submitFileUrl, obj);
      if (res.success) {
        this.removefile();
        this.innerSuccessVisible = false;
        this.innerFailedVisible = false;
        this.$emit("refresh");
        this.$store.commit("setPageLoading", false);
        this.$message.success(`${this.ossUploadParams.importText}`);
        this.$emit("submitSuccess");
      } else {
        this.$store.commit("setPageLoading", false);
        this.$message.error(`${res.message}`);
      }
    },
    handleSuccess(response, file, fileList) {},
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
        maxPos = chars.length,
        pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getDate() {
      const date = new Date(),
        year = date.getFullYear(),
        month =
          date.getMonth() > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`,
        day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`,
        hh = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`,
        mm =
          date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
      return `${year}${month}${day}${hh}${mm}`;
    },
  },
  async created() {
    const token = localStorage.getItem("token");
    this.token = token;
    this.fileUpload();
  },
  destroyed() {
    this.requestUrls = "";
    clearInterval(this.timer);
  },
};
</script>
<style>
.big {
  font-family: "PingFang SC Bold", "PingFang SC";
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  text-align: center;
  line-height: 32px;
}
.green {
  color: #008000;
}
.red {
  color: red;
}
.el-upload__tip {
  line-height: 1.2;
}
</style>
<style lang="less" scoped>
/deep/.el-upload.el-upload--text {
  text-align: left;
}
</style>
